import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import Label from 'components/form/Label/Label';
import classnames from 'classnames';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import { Link } from 'components/navigation/Link/Link';

const TitleSubtitleContainer = ({ title, subtitle, className }) => {
  return (
    <FlexContainer className={`flex-column NativeAd ${className}`}>
      <Label
        className="Subtitle-1 margB6 m-margT12 m-margB16 align-items-center m-items-align-start system_neutral_n400_text"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      ></Label>
      <Label
        className="Body-2 t-text-12 bullets-ad system_neutral_n400_text"
        dangerouslySetInnerHTML={{
          __html: subtitle,
        }}
      ></Label>
    </FlexContainer>
  );
};

const TermsContainer = ({ offerMetadata, clickTcHandler }) => {
  if (offerMetadata?.tcUrl) {
    return (
      <Link
        className="tcBlock Body-2 margT8 m-margT10 mMargB8 mtext-center"
        onClickCallback={clickTcHandler}
      >
        <span className="tcText otherLink link-style">
          {offerMetadata?.tcText || ''}
        </span>
      </Link>
    );
  }
  return <></>;
};

const NativeAdTemplate = ({
  offerMetadata,
  offerImageLinkUrlProxy,
  clickApplyImageHandler,
  clickApplyHandler,
  seenPixel,
  clickTcHandler,
  isRenderedOnFactor,
}) => {
  const isCreditCard = offerMetadata.offerType === 'CREDIT_CARD';

  const imageClassOnFactor = classnames({
    'height-127px m-height-85px': isCreditCard,
    'width-156px m-width-135px': !isCreditCard,
  });

  const imageContainerOnFactor = classnames({
    'height100px m-HeightAuto': !isCreditCard,
  });

  const imageClass = classnames({
    'width150px m-width135px': isCreditCard,
    'width-156px m-width-135px': !isCreditCard,
  });

  const imageContainer = classnames({
    'height100px m-HeightAuto': !isCreditCard,
  });
  return (
    <>
      {isRenderedOnFactor ? (
        <>
          <Disclaimer
            showPartnerText
            datatestid="NativeAdFactor"
            className={'marglr14 margT30'}
          />
          <Label
            type="subTitle4 letterSpacing06 text-weight-800 fontLato padL16 padT16"
            className={'margB10'}
          >
            SPONSORED
          </Label>
          <FlexContainer
            className={`pad16 m-padLR16 m-padTB30 grayShadow16 border-rad8px margB20 bgWhite borderYellow3 margLR16`}
          >
            <FlexContainer className="flex-column justify-around items-align-center width100 gap-5">
              <FlexContainer
                className={`flex-column t-flex-align-center items-align-center width100 justify-around`}
              >
                <FlexContainer
                  className={`justify-around imageContainer flex-row m-margr0 format100 items-align-center ${imageContainerOnFactor}`}
                >
                  <div className="imageInner">
                    {seenPixel}
                    <img
                      className={`${imageClassOnFactor} mfcenterFit mblock link`}
                      onClick={clickApplyImageHandler}
                      alt="Credit card"
                      src={offerImageLinkUrlProxy}
                    />
                  </div>
                  <FlexContainer
                    className={
                      'width160px justify-center align-items-center flex-column'
                    }
                  >
                    <Button
                      mrphType="primary"
                      rounded
                      onClick={clickApplyHandler}
                      className={'m-borderNone padTB10 width100'}
                    >
                      <FlexContainer className="justify-center align-items-center">
                        <Label type="Subtitle-2 primary_cta_text_light">
                          {offerMetadata?.buttonCopy}
                        </Label>
                      </FlexContainer>
                    </Button>
                    {offerMetadata?.applyNowLabelFlag && (
                      <Label
                        className="buttonLabel lineHeight-1-33 text-center text-12 fontGray300 margT8 m-margT6 width172px"
                        dangerouslySetInnerHTML={{
                          __html: offerMetadata.applyNowLabelText,
                        }}
                      ></Label>
                    )}
                    <TermsContainer
                      offerMetadata={offerMetadata}
                      clickTcHandler={clickTcHandler}
                    />
                  </FlexContainer>
                </FlexContainer>
                <FlexContainer className="flex-column textContainer margR24 m-margr0 width364px m-format100 m-margT10">
                  <TitleSubtitleContainer
                    className={'m-hide'}
                    title={offerMetadata?.adTitleWeb}
                    subtitle={offerMetadata?.adSubTitleWeb}
                    tooltip={offerMetadata?.tooltip}
                  />
                  <TitleSubtitleContainer
                    className={'d-hide'}
                    title={offerMetadata?.adTitleMobile}
                    subtitle={offerMetadata?.adSubTitleMobile}
                    tooltip={offerMetadata?.tooltip}
                  />
                </FlexContainer>
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </>
      ) : (
        <>
          <Label
            type="subTitle4 letterSpacing06 text-weight-800 fontLato"
            className={'margB10'}
          >
            SPONSORED
          </Label>
          <FlexContainer
            className={`pad16 m-padLR16 m-padTB30 grayShadow16 border-rad8px system_neutral_n000 borderYellow3`}
          >
            <FlexContainer className="flex-column justify-around items-align-center width100 m-flex-column gap-5">
              <FlexContainer
                className={`t-flex-column t-flex-align-center items-align-center width100 justify-around`}
              >
                <FlexContainer
                  className={`justify-between ${imageContainer} imageContainer flex-row margR24 m-margr0 m-format100`}
                >
                  <div className="imageInner">
                    {seenPixel}
                    <img
                      className={`${imageClass} mfcenterFit mblock link`}
                      onClick={clickApplyImageHandler}
                      alt="Credit card"
                      src={offerImageLinkUrlProxy}
                    />
                  </div>
                  <FlexContainer
                    className={
                      'width160px justify-center align-items-center d-hide flex-column'
                    }
                  >
                    <Button
                      mrphType="primary"
                      rounded
                      onClick={clickApplyHandler}
                      className={'m-borderNone padTB10'}
                    >
                      <FlexContainer className="justify-center align-items-center">
                        <Label type="Subtitle-2 primary_cta_text_light">
                          {offerMetadata?.buttonCopy}
                        </Label>
                      </FlexContainer>
                    </Button>
                    {offerMetadata?.applyNowLabelFlag && (
                      <Label
                        className="buttonLabel lineHeight-1-33 text-center text-12 system_neutral_n400_text margT8 m-margT6 width172px d-hide"
                        dangerouslySetInnerHTML={{
                          __html: offerMetadata.applyNowLabelText,
                        }}
                      ></Label>
                    )}
                    <TermsContainer
                      offerMetadata={offerMetadata}
                      clickTcHandler={clickTcHandler}
                    />
                  </FlexContainer>
                </FlexContainer>
                <FlexContainer className="flex-column textContainer margR24 m-margr0 width364px m-format100 m-margT10">
                  <TitleSubtitleContainer
                    className={'m-hide'}
                    title={offerMetadata?.adTitleWeb}
                    subtitle={offerMetadata?.adSubTitleWeb}
                    tooltip={offerMetadata?.tooltip}
                  />
                  <TitleSubtitleContainer
                    className={'d-hide'}
                    title={offerMetadata?.adTitleMobile}
                    subtitle={offerMetadata?.adSubTitleMobile}
                    tooltip={offerMetadata?.tooltip}
                  />
                </FlexContainer>
                <FlexContainer
                  className={`buttonContainer flex-column t-Width100`}
                >
                  <Button
                    mrphType="primary"
                    rounded
                    onClick={clickApplyHandler}
                    className={'m-borderNone width172px m-hide padTB10'}
                  >
                    <FlexContainer className="justify-center align-items-center">
                      <Label type="Subtitle-2 primary_cta_text_light">
                        {offerMetadata?.buttonCopy}
                      </Label>
                    </FlexContainer>
                  </Button>
                  {offerMetadata?.applyNowLabelFlag && (
                    <Label
                      className="buttonLabel lineHeight-1-33 text-center text-12 system_neutral_n400_text margT8 m-margT6 width172px m-hide"
                      dangerouslySetInnerHTML={{
                        __html: offerMetadata.applyNowLabelText,
                      }}
                    ></Label>
                  )}
                </FlexContainer>
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </>
      )}
    </>
  );
};

export default NativeAdTemplate;
